import './Loader.css';

export default function Loader() {
  return (
    <div className='loading-div'>
      <span className="loader"></span>
    </div>
  );
}
